import * as Types from '../Constants/AllConstants';

// Get all transactions (paged)
export const GetAllTransactionsReducer = (
  state = { transactions: [], pages: 0, page: 0 },
  action
) => {
  switch (action.type) {
    case Types.TRANSACTIONS_LIST_REQUEST:
      return { ...state, loading: true };
    case Types.TRANSACTIONS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        transactions: action.payload.content || [],
        pages: action.payload.totalPages || 0,
        page: action.payload.number || 0,
        totalElements: action.payload.totalElements || 0,
        size: action.payload.size || 15,
      };
    case Types.TRANSACTIONS_LIST_FAIL:
      return { loading: false, error: action.payload };
    case Types.TRANSACTIONS_LIST_RESET:
      return { transactions: [], pages: 0, page: 0 };
    default:
      return state;
  }
};

// Get transaction details
export const TransactionDetailsReducer = (state = { transaction: null }, action) => {
  switch (action.type) {
    case Types.TRANSACTION_DETAILS_REQUEST:
      return { loading: true };
    case Types.TRANSACTION_DETAILS_SUCCESS:
      return { loading: false, transaction: action.payload };
    case Types.TRANSACTION_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    case Types.TRANSACTION_DETAILS_RESET:
      return { transaction: null };
    default:
      return state;
  }
};

// Search transactions
export const SearchTransactionsReducer = (
  state = { transactions: [], pages: 0, page: 0 },
  action
) => {
  switch (action.type) {
    case Types.TRANSACTIONS_SEARCH_REQUEST:
      return { ...state, loading: true };
    case Types.TRANSACTIONS_SEARCH_SUCCESS:
      return {
        ...state,
        loading: false,
        transactions: action.payload.content || [],
        pages: action.payload.totalPages || 0,
        page: action.payload.number || 0,
        totalElements: action.payload.totalElements || 0,
      };
    case Types.TRANSACTIONS_SEARCH_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Get transactions by period
export const TransactionsByPeriodReducer = (
  state = { transactions: [] },
  action
) => {
  switch (action.type) {
    case Types.TRANSACTIONS_PERIOD_REQUEST:
      return { loading: true };
    case Types.TRANSACTIONS_PERIOD_SUCCESS:
      return { loading: false, transactions: action.payload };
    case Types.TRANSACTIONS_PERIOD_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Get transactions by period and status
export const TransactionsByPeriodAndStatusReducer = (
  state = { transactions: [] },
  action
) => {
  switch (action.type) {
    case Types.TRANSACTIONS_PERIOD_STATUS_REQUEST:
      return { loading: true };
    case Types.TRANSACTIONS_PERIOD_STATUS_SUCCESS:
      return { loading: false, transactions: action.payload };
    case Types.TRANSACTIONS_PERIOD_STATUS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Transactions Dashboard Metrics
export const TransactionsDashboardMetricsReducer = (
  state = { metrics: null },
  action
) => {
  switch (action.type) {
    case Types.TRANSACTIONS_METRICS_REQUEST:
      return { ...state, loading: true };
    case Types.TRANSACTIONS_METRICS_SUCCESS:
      return { loading: false, metrics: action.payload };
    case Types.TRANSACTIONS_METRICS_FAIL:
      return { loading: false, error: action.payload };
    case Types.TRANSACTIONS_METRICS_RESET:
      return { metrics: null };
    default:
      return state;
  }
};

// Export Transactions
export const ExportTransactionsReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.TRANSACTIONS_EXPORT_REQUEST:
      return { loading: true };
    case Types.TRANSACTIONS_EXPORT_SUCCESS:
      return { loading: false, success: true };
    case Types.TRANSACTIONS_EXPORT_FAIL:
      return { loading: false, error: action.payload };
    case Types.TRANSACTIONS_EXPORT_RESET:
      return {};
    default:
      return state;
  }
};

// Generate report by status
export const GenerateReportByStatusReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.TRANSACTIONS_REPORT_STATUS_REQUEST:
      return { loading: true };
    case Types.TRANSACTIONS_REPORT_STATUS_SUCCESS:
      return { loading: false, success: true };
    case Types.TRANSACTIONS_REPORT_STATUS_FAIL:
      return { loading: false, error: action.payload };
    case Types.TRANSACTIONS_REPORT_STATUS_RESET:
      return {};
    default:
      return state;
  }
};

// Generate report by time period
export const GenerateReportByTimePeriodReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.TRANSACTIONS_REPORT_PERIOD_REQUEST:
      return { loading: true };
    case Types.TRANSACTIONS_REPORT_PERIOD_SUCCESS:
      return { loading: false, success: true };
    case Types.TRANSACTIONS_REPORT_PERIOD_FAIL:
      return { loading: false, error: action.payload };
    case Types.TRANSACTIONS_REPORT_PERIOD_RESET:
      return {};
    default:
      return state;
  }
};